import { providerColumns } from './provider-columns';
import { PackingSlipSharingHeaderContent } from '../packing-slip-sharing-header';

export const HeadersFactory = {
  [providerColumns.PACKING_SLIP_SHARING]: PackingSlipSharingHeaderContent,
};
